import styled from 'styled-components';

export const MotionCardStyled = styled.div`
  width: 100%;
  background: #fff;
  border-radius: 1rem;
  padding: 1rem;
  border: 1px solid #ededed;
  margin-bottom: 1rem;

  .title {
    font-size: 1.2rem;
    font-weight: bold;
    margin-bottom: 0.5rem;
    text-align: center;
  }

  .content {
    display: flex;
    .count {
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 0.5rem 0;
    }

    .icon {
      position: relative;
      width: 5rem;
      height: 5rem;
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 50%;
      margin-bottom: 1rem;
      font-size: 2rem;

      &:before {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        width: 88%;
        height: 88%;
        border-radius: 50%;
        border: 2px solid #fff;
        content: '';
      }
    }
    .label {
      margin-bottom: 0.5rem;
      font-size: 1.2rem;
      font-weight: bold;
    }
    .count .value {
      font-weight: bold;
      font-size: 1.4rem;
    }
    .success-count .icon {
      background #17de14;
      svg polyline {
        stroke: #fff;
      }
    }
    
    .success-count .value {
      color: #17de14;
    }
    .fail-count .icon {
      background red;
      svg path {
        stroke: #fff;
      }
    }
    .fail-count .value {
      color: red;
    }
  }

  .footer {
    padding-top: 1rem;
    text-align: right;
    font-size: 1.4rem;
    font-weight: bold;

    span {
      color: ${props => props.theme.color.primary};
    }
  }
`;
